import React from "react";

export function SportSubheaderTitle({
	categoryName,
	tournamentName,
}: {
	categoryName: string;
	tournamentName: string;
}) {
	return (
		<div className="header__content header--sub__content">
			<div className="header__subtitle">{categoryName}</div>
			<div className="header--sub__inner">
				<h1 className="header__title header--sub__title">
					{tournamentName}
				</h1>
			</div>
		</div>
	);
}
